import React, { ReactNode } from 'react'
import MenuItem from '@mui/material/MenuItem'
import { Theme } from '@mui/material/styles'
import styled from 'styled-components'

import { SIZES } from '~/common/globalStyles'
import Footer from '~/views/components/Footer'
import Icon from '~/views/components/ui/Icon'
import useBrandName from '~/views/hooks/useBrandName'

const PanelContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: ${SIZES.xl};
`

interface StyledPanelLayoutProps {
  theme: Theme
  sideNavOpen?: boolean
}

export const StyledPanelLayout = styled.div<StyledPanelLayoutProps>`
  ${({ theme, sideNavOpen }) => `
    flex: 1;
    display: grid;
    grid-template-rows: ${SIZES.xxl} ${SIZES.mega} 1fr;
    grid-gap: ${SIZES.xs};
    ${theme.breakpoints?.down('md')} {
      ${
        sideNavOpen
          ? `
            &.project-panel {
              grid-template-rows: ${SIZES.xxl} ${SIZES.hyper} 1fr;
            }
          `
          : ''
      }
    } 
  `}
`

interface PanelLayoutProps {
  children: ReactNode
  hideFooter?: boolean
  panelClassName?: string
  currentView?: string
  className?: string
}

export const PanelLayout = (props: PanelLayoutProps) => {
  const { children, hideFooter, panelClassName, className } = {
    ...props,
  }
  const brandName = useBrandName()

  return (
    <PanelContainer className={className}>
      <StyledPanelLayout className={panelClassName} sideNavOpen>
        {children}
      </StyledPanelLayout>
      <Footer hide={hideFooter} brandName={brandName} />
    </PanelContainer>
  )
}

export const PanelRow = styled.div`
  margin-top: 24px;
`

export const TitleRowWithActions = styled(PanelRow)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledUnauthedLayout = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
  overflow-y: auto;
  overflow: visible;
`

const UnauthedLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const UnauthedLayout: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const brandName = useBrandName()

  return (
    <StyledUnauthedLayout>
      <UnauthedLayoutWrapper>{children}</UnauthedLayoutWrapper>
      <Footer brandName={brandName} />
    </StyledUnauthedLayout>
  )
}

export const UnauthedBody = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`

export const FlexBetween = styled.div(
  ({ theme }) => `
  display: flex;
  padding-top: ${
    theme.name === 'lightV2' ? theme.spacing(2.5) : theme.spacing(4)
  };
  justify-content: space-between;
  align-items: center;
`,
)

export const BreadCrumbArrow = styled(Icon)(
  ({ theme }) => `
  margin: 0 ${theme.spacing(2)};
  max-height: ${theme.spacing(4)};
`,
)

export const StyledMenuItem = styled(MenuItem)`
  color: inherit;
`

export const ChildrenWrapper = styled.div(
  ({ theme }) => `
  padding-top: ${theme.spacing(3)};
  height: 100%;
  display: flex;
  flex-direction: column;
`,
)

export const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
`
